'use client';

import { memo } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { useTranslations } from 'next-intl';

import { PlaygroundFile } from '@entities/module';
import { Button } from '@shared/ui/components';
import ArrowIcon from '@public/icons/arrow-external.svg';

import styles from './PlaygroundCard.module.scss';

interface PlaygroundCardProps {
  playground: PlaygroundFile;
}

const PlaygroundCard = memo((props: PlaygroundCardProps) => {
  const { playground } = props;

  const t = useTranslations('modules');

  return (
    <div className={styles.container}>
      <div className={styles.title}>{playground.fileName}</div>

      <Link href={playground.link} target="_blank" className={styles.link}>
        <Button size="s" variant="filled">
          <div>{t('tryIt')}</div>
          <Image src={ArrowIcon} alt="Arrow" draggable={false} />
        </Button>
      </Link>
    </div>
  );
});

export default PlaygroundCard;
